// 站点级共享配置
// 企业微信客服咨询入口：所有「立即咨询」按钮统一跳转此地址
export const WECHAT_WORK_CONSULT_URL = 'https://work.weixin.qq.com/kfid/kfc74581ebac764f7e5'

// 全局默认封面图：活动 / 投资资讯 / 政经动态 三类卡片在图片字段为空
// （undefined / null / 'null' / 'NULL' / 空串 / 纯空白）时回退到对应默认值。
// 在 src/api/home.js 的字段归一化处统一应用，列表页与首页区块自动受益。
export const DEFAULT_COVER_IMAGES = {
  // 活动（商务活动 / 活动邀请）
  activity: 'https://res.roadlinkglb.com/pic/活动邀请/640.png',
  // 投资资讯
  investment: 'https://res.roadlinkglb.com/images/2026/08/31/%E6%8A%95%E8%B5%84%E8%B5%84%E8%AE%AF.jpg',
  // 政经动态
  dynamics: 'https://res.roadlinkglb.com/pic/mini/zhengjingdongtai/background.jpg'
}
